import React from 'react';
import { Outlet } from 'react-router-dom';

const ProjectTabs = () => {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
};

export default ProjectTabs;
